export const TYPE_BUG = 'bug'
export const TYPE_ENHANCEMENT = 'enhancement'
export const TYPE_TASK = 'task'
export const REPORT_TYPES = {}
REPORT_TYPES[TYPE_BUG] = 'async.bugreport.error'
REPORT_TYPES[TYPE_ENHANCEMENT] = 'async.bugreport.enhancement'
REPORT_TYPES[TYPE_TASK] = 'async.bugreport.accessibility'
